/**
 * Property type helpers.
 *
 * Travela has exactly two presentation modes:
 *   - "hotel-portfolio" listings (multi-room hotels)  → /hotel/[id]
 *   - everything else (regular single listings)       → /listing/[id]
 *
 * These helpers centralize that check so callers stop reaching into
 * `property_type.slug` strings directly.
 */

const PROPERTY_TYPE_HOTEL_PORTFOLIO = "hotel-portfolio";

/** Minimal shape we need; works with both API `Listing` and booking listings. */
interface IListingLike {
  property_type?: { slug?: string | null } | null;
  is_hotel?: boolean | null;
}

/**
 * True when the listing represents a hotel-portfolio (multi-room hotel).
 * Accepts the listing object directly or `null/undefined`.
 */
export function isHotelPortfolio(listing?: IListingLike | null): boolean {
  if (!listing) return false;
  if (listing.is_hotel === true) return true;
  return listing.property_type?.slug === PROPERTY_TYPE_HOTEL_PORTFOLIO;
}

/**
 * The correct details-page URL for a listing — `/hotel/{id}` for hotels,
 * `/listing/{id}` otherwise.
 */
export function listingDetailsHref(
  listing: IListingLike & { id: number | string },
): string {
  return isHotelPortfolio(listing)
    ? `/hotel/${listing.id}`
    : `/listing/${listing.id}`;
}
